import { useState } from 'react';
import { useDeviceType } from '../store/device-type';
import { useConfig } from '../store/reducers/config';
import { tabletSize } from './responsive';

type InfoPanelPosition = 'bottom' | null;

const useInfoPanelPosition = (): InfoPanelPosition => {
  const deviceType = useDeviceType();
  const { isVault } = useConfig();
  let infoPanelPosition: InfoPanelPosition;
  const [deviceSize, setDeviceSize] = useState(tabletSize(deviceType));
  const handleResize = (): void => {
    setDeviceSize(tabletSize(deviceType));
  };

  window.addEventListener('resize', handleResize);

  if (deviceType === 'mobile') {
    infoPanelPosition = 'bottom';
  } else if (isVault) {
    infoPanelPosition = null;
  } else if (deviceSize === 'isTwentyTwoInch') {
    infoPanelPosition = null;
  } else if (deviceSize === 'isTenInch') {
    infoPanelPosition = 'bottom';
  } else if (deviceSize === 'isSevenInch') {
    infoPanelPosition = 'bottom';
  }

  return infoPanelPosition;
};

export default useInfoPanelPosition;
